import { lazy as reactLazy, type ComponentType, type LazyExoticComponent } from 'react';
import { CHUNK_LOAD_RELOAD_SESSION_KEY, isChunkLoadFailure } from '@/lib/chunk-load-errors';

/**
 * Comme `React.lazy`, mais après un déploiement Vite : si le chunk hashé a disparu,
 * on recharge la page une fois pour récupérer le nouveau `index.html` + bons chemins.
 */
export function lazy<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>,
): LazyExoticComponent<T> {
  return reactLazy(() =>
    factory().catch((err: unknown) => {
      if (isChunkLoadFailure(err) && typeof window !== 'undefined') {
        const already = window.sessionStorage.getItem(CHUNK_LOAD_RELOAD_SESSION_KEY) === '1';
        if (!already) {
          window.sessionStorage.setItem(CHUNK_LOAD_RELOAD_SESSION_KEY, '1');
          window.location.reload();
          return new Promise<{ default: T }>(() => {
            /* jamais résolu : navigation imminente */
          });
        }
      }
      throw err;
    }),
  );
}
